import { ProductService } from './../../../../../api/product.service';
import { DocumentService } from './../../../../../api/document.service';
import { AppModalListProductKonvaComponent } from './app-technical-documents/app-modal-list-product-konva/app-modal-list-product-konva.component';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { FlatTreeControl } from '@angular/cdk/tree';
import { ChangeDetectorRef, Component, Injectable, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from '@angular/material';
import { CategoryService } from '@app/api/api';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, of as observableOf, Subject } from 'rxjs';
import { AppModalEditCatalogComponent } from './app-modal-edit-catalog/app-modal-edit-catalog.component';
import { LayoutUtilsService } from '@app/core/_base/crud';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { environment } from 'environments/environment';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

// ... (Giữ nguyên các class TodoItemNode, TodoItemFlatNode, ChecklistDatabase) ...
export class TodoItemNode {
  id: string;
  name: string;
  path: string;
  children: TodoItemNode[];
  parent_id: string;
  priority: any;
  image: string;
  is_hide: boolean;
}

export class TodoItemFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  path: string;
  id: string;
  parent_id: string;
  priority: any;
  image: string;
  is_hide: boolean;
}

let TREE_DATA = [];
@Injectable()
export class ChecklistDatabase {
  dataChange = new BehaviorSubject<TodoItemNode[]>([]);

  dataTree = [];

  get data(): TodoItemNode[] {
    if (this.dataChange != undefined) {
      return this.dataChange.value;
    }
  }

  constructor(private categoryService: CategoryService, private ref: ChangeDetectorRef) {
    this.getTreeCategories();
    this.initialize();
  }

  initialize() {
    const data = this.buildFileTree(TREE_DATA, 0);
    this.dataChange.next(data);
    //this.ref.detectChanges();
  }
  getTreeCategories() {
    this.categoryService.apiCategoriesWithPriority(true, 'body', true).subscribe((r) => {
      if (r.success) {
        this.getTreeData(r.data);
      }
    });
  }
  getTreeData(data): Observable<any> {
    this.dataTree = data;

    TREE_DATA = this.buildTree(this.dataTree);
    this.initialize();

    // this.categoryService.apiCategoriesGet().subscribe(res => {
    //   if (res.success) {
    //     this.dataTree = res.data
    //     TREE_DATA = this.buildTree(this.dataTree);
    //     this.initialize();
    //   }
    // })
    return;
  }

  buildTree(data) {
    data.push({
      id: null,
      name: 'Tất cả danh mục',
      parent_id: 'root',
    });
    let rootNode = data.filter((x) => x.parent_id == 'root');

    let treeobject = [];
    rootNode.forEach((element) => {
      let aChildren = data.filter((x) => x.parent_id == element.id);
      const node = new TodoItemNode();
      node.id = element.id;
      node.name = element.name;
      node.parent_id = element.parent_id;
      node.path = element.name;

      let lstChildren = this.builDataChildren(aChildren, data, node);
      node.children = lstChildren;
      treeobject.push(node);
    });

    return treeobject;
  }

  builDataChildren(aChildren, allChildren, parent) {
    let objectReturn = [];
    aChildren.forEach((element) => {
      let aChild = allChildren.filter((x) => x.parent_id == element.id);
      const node = new TodoItemNode();
      node.id = element.id;
      node.name = element.name;
      node.path = parent.path + ' › ' + element.name;
      let lstChildrenNode = this.builDataChildren(aChild, allChildren, node);
      node.children = lstChildrenNode;
      node.priority = element.priority;
      node.image = element.image;
      node.is_hide = element.is_hide;
      node.parent_id = element.parent_id;
      objectReturn.push(node);
    });
    return objectReturn;
  }

  buildFileTree(obj, level: number): TodoItemNode[] {
    return obj.reduce((accumulator: any, item) => {
      const node = new TodoItemNode();
      node.id = item.id;
      node.name = item.name;
      node.path = item.path;
      node.parent_id = item.parent_id;
      if (item.children != undefined) {
        if (item.children.length > 0) {
          node.children = this.buildFileTree(item.children, level + 1);
        } else {
          node.id = item.id;
          node.name = item.name;
          node.path = item.path;
          node.parent_id = item.parent_id;
        }
      }
      return accumulator.concat(node);
    }, []);
  }

  public filter(filterText: string) {
    let filteredTreeData;
    if (filterText) {
      filteredTreeData = TREE_DATA.filter(
        (d) => d.name.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) > -1
      );
      Object.assign([], filteredTreeData).forEach((ftd) => {
        let str = <string>ftd.name;
        while (str.lastIndexOf('.') > -1) {
          const index = str.lastIndexOf('.');
          str = str.substring(0, index);
          if (filteredTreeData.findIndex((t) => t.name === str) === -1) {
            const obj = TREE_DATA.find((d) => d.name === str);
            if (obj) {
              filteredTreeData.push(obj);
            }
          }
        }
      });
    } else {
      filteredTreeData = TREE_DATA;
    }
    const data = this.buildFileTree(filteredTreeData, 0);
    this.dataChange.next(data);
  }
}
@Component({
  selector: 'meu-app-catalog-management',
  templateUrl: './app-catalog-management.component.html',
  styleUrls: ['./app-catalog-management.component.scss'],
  providers: [ChecklistDatabase],
})
export class AppCatalogManagementComponent implements OnInit {
  choosePath = '';
  //@Output() currentNode = new EventEmitter<string>();
  host: string = environment.backendhost;

  private _transformer = (node: TodoItemNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
      path: node.path,
      id: node.id,
      priority: node.priority,
      is_hide: node.is_hide,
      parent_id: node.parent_id,
      image: node.image,
    };
  };

  treeControl = new FlatTreeControl<TodoItemFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: TodoItemFlatNode) => node.expandable;
  displayedColumns: string[] = ['index', 'name', 'code', 'action'];

  dataSearchBasic: any = '';
  filter = '';

  selectedNode: any = { id: null };
  nodeIndex: number;

  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();
  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();

  constructor(
    //public dialogRef: MatDialogRef<AppModalEditCatalogComponent>,
    private toastr: ToastrService,
    private database: ChecklistDatabase,
    private categoryService: CategoryService,
    private documentService: DocumentService,
    private productService: ProductService,
    public dialog: MatDialog,
    public ref: ChangeDetectorRef,
    public layoutUtilsService: LayoutUtilsService,
    private router: Router,
    private location: Location,
    private route: ActivatedRoute
  ) {
    this.getTreeCategories();
  }
  lstAllCategories: any = [];
  lstParentName: any = [];
  lstParentID: any = [];
  tabName: any = 'document';

  lstAllDocument: any = [];
  totalDocument: any;
  pagesizeDocument: any = 10;
  pageIndexDocument: any = 1;

  lstAllProduct: any = [];
  totalProduct: any;
  pagesizeProduct: any = 10;
  pageIndexProduct: any = 1;

  // Thêm dòng này
  pageSizeOptions: number[] = [5, 10, 20, 100];

  ngOnInit() {
    this.getTreeCategories();
  }
  deleteDocumentByDocumentID(documentId) {
    const title = 'Xóa tài liệu';
    const description = 'Bạn có chắc chắn muốn xóa tài liệu này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.documentService.apiDocumentsIdDelete(documentId).subscribe((res) => {
          if (res.success) {
            this.getAllDocumentByCategoryID();
            this.toastr.success('Xoá dữ liệu thành công');
          } else {
            this.toastr.error('Xoá dữ liệu không thành công');
          }
        });
      }
    });
  }
  deleteProductByProductID(productId) {
    const title = 'Xóa sản phẩm';
    const description = 'Bạn có chắc chắn muốn xóa sản phẩm này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.productService.apiProductsIdDelete(productId).subscribe((res) => {
          if (res.success) {
            this.getAllProductByCategoryID();
          }
        });
      }
    });
  }
  getAllDocumentByCategoryID() {
    this.categoryService
      .apiCategoriesIdDocumentsGet(
        this.selectedNode.id,
        '',
        '',
        this.pageIndexDocument,
        this.pagesizeDocument
      )
      .subscribe((res) => {
        if (res.success) {
          this.lstAllDocument = res.data.collection;
          this.lstAllDocument = [...this.lstAllDocument];
          // this.pageIndexDocument = res.data.pageIndex; // Tắt
          // this.pagesizeDocument = res.data.pagesize; // Tắt
          this.totalDocument = res.data.total;
          this.ref.detectChanges();
        }
      });
  }
  getAllProductByCategoryID() {
    this.categoryService
      .apiCategoriesIdProductsGet(
        this.selectedNode.id,
        '',
        '',
        this.pageIndexProduct,
        this.pagesizeProduct
      )
      .subscribe((res) => {
        if (res.success) {
          this.lstAllProduct = res.data.collection;
          this.lstAllProduct = [...this.lstAllProduct];
          // this.pageIndexProduct = res.data.pageIndex; // Tắt
          // this.pagesizeProduct = res.data.pagesize; // Tắt
          this.totalProduct = res.data.total;
          this.ref.detectChanges();
        }
      });
  }

  // --- THAY THẾ LOGIC PHÂN TRANG ---
  // Xóa hàm paginatorChange(event) và thay bằng các hàm sau:

  // --- Tab Tài liệu ---
  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndexDocument = pageNumber;
      this.getAllDocumentByCategoryID();
      window.scrollTo(0, 0);
    }
  }


  sortTree(data: any[]): any[] {
    return data
      .map((item) => ({
        ...item,
        children: item.children ? this.sortTree(item.children) : [],
      }))
      .sort((a, b) => {
        const pa = a.priority != null ? a.priority : Number.MAX_SAFE_INTEGER;
        const pb = b.priority != null ? b.priority : Number.MAX_SAFE_INTEGER;
        return pa - pb;
      });
  }


  onPageSizeChange(newSize: number) {
    this.pagesizeDocument = newSize;
    this.pageIndexDocument = 1; // Quay về trang 1
    this.getAllDocumentByCategoryID();
  }

  // --- Tab Sản phẩm ---
  onPageChangeProduct(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndexProduct = pageNumber;
      this.getAllProductByCategoryID();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChangeProduct(newSize: number) {
    this.pagesizeProduct = newSize;
    this.pageIndexProduct = 1; // Quay về trang 1
    this.getAllProductByCategoryID();
  }
  // --- KẾT THÚC THAY THẾ ---


  getTreeCategories() {
    this.lstParentID = []; // reset
    this.lstParentName = []; // reset
    this.categoryService.apiCategoriesWithPriority(false, 'body', true).subscribe((r) => {
      if (r.success) {
     
        this.database.getTreeData(r.data);
        this.lstAllCategories = r.data;
        this.dataSource.data = this.sortTree(TREE_DATA);
   
        if (this.route.snapshot.fragment != null && this.route.snapshot.fragment != undefined) {
          let node = this.treeControl.dataNodes.find((x) => x.id == this.route.snapshot.fragment);
          this.getParentNode(node.id);
          for (let i = this.lstParentID.length - 1; i >= 0; i--) {
            let nodeOpen = this.treeControl.dataNodes.find((x) => x.id == this.lstParentID[i]);
            this.treeControl.expand(nodeOpen);
          }
          this.treeControl.expand(node);
          this.selectedNode = node;
          this.getAllDocumentByCategoryID();
          this.getAllProductByCategoryID();
        }
      }
    });
  }
  tabClick(event) {
    switch (event.index) {
      case 0:
        this.tabName = 'document';
        break;
      case 1:
        this.tabName = 'product';
        break;
      default:
      // code block
    }
  }
  deleteCatalog(id) {
    const title = 'Xóa danh mục';
    const description = 'Bạn có chắc chắn muốn xóa danh mục này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        let arr = this.lstAllCategories.filter((x) => x.parent_id == id);
        if (arr && arr.length > 0) {
          this.toastr.warning('Vui lòng xóa danh mục con');
          return;
        }
        this.categoryService.apiCategoriesIdDelete(id).subscribe((res) => {
          if (res.success) {
            let idParent = this.lstAllCategories.find((x) => x.id == id).parent_id;
            if (idParent != null) {
              this.location.replaceState('/admin/catalog-management' + '#' + idParent);
            }

            this.getTreeCategories();
          } else {
            this.toastr.error(res.message, 'Xoá thất bại');
          }
        });
      }
    });
  }
  closeModal() {
    //this.dialogRef.close({ event: false });
  }
  transformer = (node: TodoItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.name === node.name ? existingNode : new TodoItemFlatNode();
    flatNode.name = node.name;
    flatNode.path = node.path;
    flatNode.level = level;
    flatNode.id = node.id;
    flatNode.expandable = !!node.children;
    flatNode.parent_id = node.parent_id;
    flatNode.image = node.image;
    flatNode.priority = node.priority;
    flatNode.is_hide = node.is_hide;
    (flatNode.parent_id = node.parent_id), this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };
  filterChanged(filterText: string) {
    this.database.filter(filterText);
    if (filterText) {
      this.treeControl.expandAll();
    } else {
      this.treeControl.collapseAll();
    }
  }
  getCurrentNode(node, index) {

    this.nodeIndex = index;
    this.selectedNode = node;
    this.choosePath = this.selectedNode.path;

    if (node.id != null) {
      this.location.replaceState('/admin/catalog-management' + '#' + node.id);
      this.getAllDocumentByCategoryID();
      this.getAllProductByCategoryID();
    }
  }
  nextPageDocument(element) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([
      '/admin/catalog-management/' + this.selectedNode.id + '/document/' + element.id + '/edit',
    ]);
  }
  openModalEditCatalog(id, type) {
    this.lstParentName = [];

    let nodeChoosed = this.lstAllCategories.find((x) => x.id == id);
    this.lstParentName.push(nodeChoosed.name);
    this.getParentNode(nodeChoosed.parent_id);

    const dialogRef = this.dialog.open(AppModalEditCatalogComponent, {
      width: '800px',
      data: {
        selectedNodeId: this.selectedNode.id,
        lstParentName: this.lstParentName,
        type: type,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.event) {
        if (result.type == 'edit') {
          // let index =  this.dataSource.data.findIndex(x=>x.id == result.result.id);
          // this.dataSource.data[index] = result.result;
          this.getTreeCategories();
        } else {
          this.getTreeCategories();
        }
      }
      this.lstParentName = [];
    });
  }
  getListParentName() {
    this.lstParentName = [];
    let nodeChoosed = this.lstAllCategories.find((x) => x.id == this.selectedNode.id);
    this.lstParentName.push(nodeChoosed.name);
    this.getParentNode(nodeChoosed.parent_id);
  }
  getParentNode(parentID) {
    for (let index = 0; index < this.lstAllCategories.length; index++) {
      if (
        this.lstAllCategories[index].id == null &&
        this.lstParentID.findIndex((x) => x == null) != -1
      ) {
        continue;
      }
      if (this.lstAllCategories[index].id == parentID) {
        this.lstParentID.push(this.lstAllCategories[index].id);
        this.lstParentName.push(this.lstAllCategories[index].name);
        if (this.lstAllCategories[index].parent_id != 'root') {
          this.getParentNode(this.lstAllCategories[index].parent_id);
        } else {
          return;
        }
      }
    }
  }

  setHide(idNode, body) {
    // reset trạng thái trước khi render lại tree
    this.selectedNode = null;
    this.nodeIndex = null;
    this.choosePath = '';

    this.categoryService.apiCategoriesIdPut(idNode, body).subscribe((res) => {
      if (res.success) {
        this.getTreeCategories();
      }
    });
  }
}
